import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchBanks } from "../features/banks/bankSlice";

import BankForm from "./BankForm";
import BankTable from "./BankTable";

function Banks() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.banks
    );

    useEffect(() => {

        dispatch(fetchBanks());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <BankForm />

                </div>

                <div className="col-lg-8">

                    <BankTable />

                </div>

            </div>

        </div>

    );

}

export default Banks;